module.exports = __webpack_public_path__ + "img/7efs.60720df4.gif";